import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

interface SiteTheme {
  id: string;
  alias: string;
}

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly theme: SiteTheme = {
    id: 'design-a-field-journal',
    alias: 'da'
  };

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    this.applyTheme();
  }

  private applyTheme(): void {
    const body = this.document.body;
    const root = this.document.documentElement;
    const retiredAliases = new Set(['da', 'db', 'dc', 'dd', 'de', 'df', 'dg', 'dh', 'di']);

    Array.from(body.classList).forEach((className) => {
      if (className.startsWith('design-') || retiredAliases.has(className)) {
        body.classList.remove(className);
      }
    });

    body.classList.add(`design-${this.theme.id}`, this.theme.alias);
    body.setAttribute('data-design-concept', this.theme.id);
    root.setAttribute('data-design-concept', this.theme.id);
  }
}
